import { apiClient } from "../index";

const UNIVERSITY_STUDENTS_PATH = "/api/v1/auth/university-students";

export async function createUniversityStudent(studentData) {
  const payload = {
    full_name: studentData.full_name,
    username: studentData.username,
    email: studentData.email,
    dob: studentData.dob,
    organization_name: studentData.organization_name,
  };

  return apiClient.post(UNIVERSITY_STUDENTS_PATH, payload);
}
